/* AA header behaviour: mega panels (hover + click/Enter), mobile accordion menu, cart count sync. */
(function () {
  var root = document.querySelector('[data-aa-header]');
  if (!root || root.__aaInit) return;
  root.__aaInit = true;

  var triggers = [].slice.call(root.querySelectorAll('[data-aa-trigger]'));
  var underlay = root.querySelector('[data-aa-underlay]');
  var mq = window.matchMedia('(min-width: 990px)');
  var current = null;
  var openedBy = null;

  function panelOf(t) { return document.getElementById(t.getAttribute('aria-controls')); }

  /* close = reverse animation (.is-closing, .18s) and then hidden on animationend; a timer backs it up */
  function cancelClosing(el) {
    if (!el || !el.__closing) return;
    el.__closing = false; clearTimeout(el.__ct); el.classList.remove('is-closing');
    if (el.__onend) el.removeEventListener('animationend', el.__onend);
  }
  function hideAnimated(el) {
    if (!el || el.hidden || el.__closing) return;
    el.__closing = true;
    el.classList.add('is-closing');
    var done = function () {
      if (!el.__closing) return;
      el.__closing = false; clearTimeout(el.__ct);
      el.removeEventListener('animationend', el.__onend);
      el.classList.remove('is-closing'); el.hidden = true;
    };
    el.__onend = function (e) { if (e.target === el) done(); };
    el.addEventListener('animationend', el.__onend);
    el.__ct = setTimeout(done, 300);
  }
  var leaveTimer = null;
  function closePanels(restoreFocus) {
    clearTimeout(leaveTimer);
    if (!current) return;
    var t = current;
    current = null; openedBy = null;
    triggers.forEach(function (x) { x.setAttribute('aria-expanded', 'false'); hideAnimated(panelOf(x)); });
    hideAnimated(underlay);
    if (restoreFocus) t.focus();
  }

  // Align the panel's column grid with the left edge of the nav group label ("shop" / "featured") the trigger sits in.
  function alignPanel(panel, t) {
    var grp = t.closest('.aa-hdr__group');
    var lbl = grp && (grp.querySelector('.aa-label') || t);
    if (!lbl) return;
    panel.style.setProperty('--aa-panel-x', Math.max(16, Math.round(lbl.getBoundingClientRect().left)) + 'px');
  }
  window.addEventListener('resize', function () { if (current) alignPanel(panelOf(current), current); });

  function openPanel(t, how) {
    clearTimeout(leaveTimer);
    if (current === t) { openedBy = how === 'hover' && openedBy ? openedBy : how; return; }
    triggers.forEach(function (x) { x.setAttribute('aria-expanded', 'false'); var p = panelOf(x); if (p) { cancelClosing(p); p.hidden = true; } });
    var panel = panelOf(t);
    if (!panel) return;
    t.setAttribute('aria-expanded', 'true');
    cancelClosing(panel);
    panel.hidden = false;
    alignPanel(panel, t);
    if (underlay) { cancelClosing(underlay); underlay.hidden = false; }
    current = t; openedBy = how;
  }

  // Triggers are links (Oct 21): a mouse click follows the link (hover already opened the panel). A touch tap on a closed
  // panel opens it instead (no hover on tablets), and a second tap follows the link. Enter on the keyboard opens the panel
  // and moves focus into it, as before; its "shop all" link goes to the same page.
  var lastPointer = 'mouse';
  triggers.forEach(function (t) {
    t.addEventListener('pointerdown', function (e) { lastPointer = e.pointerType || 'mouse'; });
    t.addEventListener('mouseenter', function () { if (mq.matches) openPanel(t, 'hover'); });
    t.addEventListener('click', function (e) {
      if (!mq.matches) return;
      var kb = e.detail === 0;
      if (!kb && lastPointer === 'mouse' && t.getAttribute('href') !== '#') return;
      if (!kb && current === t && openedBy === 'click' && t.getAttribute('href') !== '#') return;
      e.preventDefault();
      if (current === t && openedBy === 'click') { closePanels(false); return; }
      openPanel(t, 'click');
      if (kb) { var f = panelOf(t).querySelector('a, button'); if (f) f.focus(); }
    });
  });

  // plain links, search, account group: entering closes any open panel (as in the mockup)
  [].slice.call(root.querySelectorAll('[data-aa-close-on-enter], [data-aa-nav-plain]')).forEach(function (el) {
    el.addEventListener('mouseenter', function () { closePanels(false); });
  });
  // leaving the header closes the menu after a short grace period, so a slightly wobbly pointer path does not flicker it shut
  root.addEventListener('mouseleave', function () {
    if (openedBy !== 'hover' && openedBy !== 'click') return;
    clearTimeout(leaveTimer);
    leaveTimer = setTimeout(function () { if (openedBy === 'hover' || openedBy === 'click') closePanels(false); }, 120);
  });
  root.addEventListener('mouseenter', function () { clearTimeout(leaveTimer); });
  [].forEach.call(root.querySelectorAll('[data-aa-panel]'), function (p) { p.addEventListener('mouseenter', function () { clearTimeout(leaveTimer); }); });
  if (underlay) {
    underlay.addEventListener('mouseenter', function () { if (!current) return; clearTimeout(leaveTimer); leaveTimer = setTimeout(function () { closePanels(false); }, 120); });
    underlay.addEventListener('click', function () { closePanels(false); });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (current) closePanels(true);
    else if (menuOpen) setMenu(false, true);
  });

  /* ---- mobile menu ---- */
  var burger = root.querySelector('[data-aa-burger]');
  var mmenu = root.querySelector('[data-aa-mmenu]');
  var menuOpen = false;
  function setMenu(open, restoreFocus) {
    menuOpen = open;
    if (!burger || !mmenu) return;
    if (open) { cancelClosing(mmenu); mmenu.hidden = false; } else { hideAnimated(mmenu); }
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    burger.setAttribute('aria-label', open ? 'Close menu' : 'Menu');
    burger.querySelector('[data-aa-burger-open]').hidden = open;
    burger.querySelector('[data-aa-burger-close]').hidden = !open;
    document.documentElement.classList.toggle('aa-menu-open', open);
    // background content (main + footer) is inert while the full-screen menu is open; the burger stays reachable to close it
    [].forEach.call(document.querySelectorAll('#MainContent, .shopify-section-group-footer-group'), function (el) {
      if (open) el.setAttribute('inert', ''); else el.removeAttribute('inert');
    });
    if (!open && restoreFocus) burger.focus();
  }
  if (burger) burger.addEventListener('click', function () { setMenu(!menuOpen, false); });

  var accs = [].slice.call(root.querySelectorAll('[data-aa-acc]'));
  accs.forEach(function (b) {
    b.addEventListener('click', function () {
      var willOpen = b.getAttribute('aria-expanded') !== 'true';
      accs.forEach(function (x) {
        var on = x === b && willOpen;
        x.setAttribute('aria-expanded', on ? 'true' : 'false');
        document.getElementById(x.getAttribute('aria-controls')).hidden = !on;
        x.querySelector('[data-aa-plus]').hidden = on;
        x.querySelector('[data-aa-minus]').hidden = !on;
      });
    });
  });

  mq.addEventListener('change', function () {
    closePanels(false);
    triggers.forEach(function (x) { var p = panelOf(x); if (p) { cancelClosing(p); p.hidden = true; } });
    if (underlay) { cancelClosing(underlay); underlay.hidden = true; }
    if (mq.matches) { setMenu(false, false); cancelClosing(mmenu); if (mmenu) mmenu.hidden = true; }
  });

  /* ---- sizing vars used by stock sticky elements ---- */
  function setVars() {
    var h = root.offsetHeight;
    var d = document.documentElement.style;
    d.setProperty('--header-height', h + 'px');
    d.setProperty('--header-sticky-height', h + 'px');
    d.setProperty('--aa-hdr-h', h + 'px');
  }
  setVars();
  window.addEventListener('resize', setVars);
  window.addEventListener('load', setVars);
  document.addEventListener('theme:vars', setVars);

  /* ---- cart count ---- */
  var nodes = [].slice.call(root.querySelectorAll('[data-aa-cart-count]'));
  var mnode = root.querySelector('[data-aa-cart-count-m]');
  var dwrap = [].slice.call(root.querySelectorAll('[data-aa-cart-n]'));
  function render(n) {
    nodes.forEach(function (el) { el.textContent = n; });
    dwrap.forEach(function (el) { el.hidden = !n; });
    if (mnode) { mnode.textContent = ' (' + n + ')'; mnode.hidden = !n; }
  }
  var pending = null;
  function refresh() {
    clearTimeout(pending);
    pending = setTimeout(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) { render(c.item_count); })
        .catch(function () {});
    }, 150);
  }
  ['theme:cart:added', 'theme:cart:refresh', 'theme:cart:update', 'theme:cart:loaded', 'theme:cart:close'].forEach(function (ev) {
    document.addEventListener(ev, refresh);
  });
  // stock drawer updates its own qty node after line changes; mirror it
  var drawerQty = document.querySelector('[data-cart-items-qty]');
  if (drawerQty && window.MutationObserver) {
    new MutationObserver(function () { var n = parseInt(drawerQty.textContent, 10); if (!isNaN(n)) render(n); })
      .observe(drawerQty, { childList: true, characterData: true, subtree: true });
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
})();
